// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"936":"2a5b68d0","3259":"31947cdc","5771":"189e1c45","5895":"88850ba7","6431":"3a331e4d","7440":"d3ba3618","9696":"b56ce4e1"}[chunkId] + ".chunk.css";
};